<template>
    <div>
    <el-breadcrumb separator="/" class="bread">
        <el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
        <!-- 操作-->

        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left">
            <el-form :inline="true" :model="topForm" ref="topForm">

                <el-form-item prop="rolename">
                    <el-input v-model="topForm.rolename" placeholder="角色名称" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="" @click="getData" icon="search":loading="loading">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="dialogFormVisible = true"    v-if=" btnAll.btn_0431">新增</el-button>
                </el-form-item>

                <el-form-item >
                    <el-button type="primary" @click="resetForm('topForm')">重置</el-button>
                </el-form-item>

            </el-form>
        </el-col>
        <!-- 弹窗新增标签-->
        <!--<el-button type="text" >打开嵌套表单的 Dialog</el-button>-->

        <el-dialog title="角色" :visible.sync="dialogFormVisible" :modal-append-to-body="false" @close="cleanValue">
            <el-form  :model="roleForm" :rules="rolerules" ref="roleForm"  >

                <el-form-item label="角色名称" prop="name">
                    <el-input  v-model="roleForm.name"></el-input>
                </el-form-item>


                <el-form-item label="登录权限" prop="checkLevel">
                    <el-select  v-model="roleForm.checkLevel" placeholder="请选择">
                        <el-option  value="store001" label="超级管理员">超级管理员</el-option>
                        <el-option  value="storeIdXi4672" label="咪咕租户">咪咕租户</el-option>
                        <el-option  value="storeIdAGm1qf" label="19八3租户">19八3租户</el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="备注" prop="remark">
                    <el-input v-model="roleForm.remark"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('roleForm')">保存</el-button>
                <!--<el-button type="primary" @click="dialogFormVisible = false">保存</el-button>-->
            </div>
        </el-dialog>


        <!-- 表格分页-->
        <div class="block">
            <el-table :data="tableData" border style="width: 100%;" >
                <el-table-column prop="role_id" label="id">  </el-table-column>
                <el-table-column prop="name" label="角色名称" > </el-table-column>
                <el-table-column prop="remark" label="备注" > </el-table-column>
                <el-table-column prop="time" label="更新时间"  :formatter="formatter"  sortable >  </el-table-column>
                <el-table-column label="操作" width="280">
                    <template scope="scope">
                        <el-button  size="small" @click="roleEdit(scope.row)" v-if=" btnAll.btn_0432" >编辑</el-button> <!-- v-bind:class="{ clearBtn: btnAll.btn_0432 }"  v-bind:class="{ clearBtn: btnAll.btn_0433 }"    v-bind:class="{ clearBtn: btnAll.btn_0434 }"  -->
                        <el-button  size="small" type="danger"  @click="handleDelete(scope.row)"  v-if=" btnAll.btn_0433" >删除</el-button>
                        <el-button  size="small" type="info" @click="RolesRes(scope.row)" v-if=" btnAll.btn_0434" >绑定权限</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>



        <div class="block">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    //import ElSelect from "../../../../node_modules/element-ui/packages/select/src/select.vue";
    //import ElOption from "../../../../node_modules/element-ui/packages/select/src/option.vue";
    export  default{
        //components: {
        // ElOption,
        //  ElSelect},
        data(){
            var validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入角色名称！'));
                } else {
                    if(this.edit == false){
                        this.$http.post(this.requetHost+"/sys/role/roleValidate",{name:value}).then(response => {
                            if (response.status === 200) {
                                if (response.body.res === "success"){
                                    callback(new Error('角色名称已存在请重新输入！'));
                                }else{
                                    callback();
                                }
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'
                            });
                        })
                    }else{
                        callback();
                    }
                }
            };
            var validateRemark = (rule, value, callback) => {
//                if (value === '') {
//                    callback(new Error('请输入备注！'));
//                }else {
                    if(value.length>20){
                        callback(new Error('备注不能多于20个字！'));
                    }else{
                        callback();
                    }
//                }
            };
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                //参数设置
                url: this.requetHost+"/sys/role/findRolesList", // 分页查询请求路径
                topForm:{
                    rolename:''
                },
                loading:false,
                /*弹窗选择*/
                dialogFormVisible: false,
                edit:false,
                /*弹窗内容选择*/
                roleForm:{
                    role_id:'',
                    name:'',
                    isCheckRole:'1',
                    checkLevel:'store001',
                    remark:''
                },
                rolerules: {
                    name: [
                        {required: true,message: '请输入角色名称', trigger: 'blur'},
                        { validator: validateName, trigger: 'blur' },
                        { validator: this.validatorSpace, trigger: 'blur' },
                        { validator: this.validatorCharmap, trigger: 'blur' },
                        { min: 2, max: 16, message: '长度在 2到 16 个字符', trigger: 'blur' },
                    ],
                    remark: [
                        { validator: validateRemark, trigger: 'blur' },
                        { min: 0, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' },
                    ]
                },btnAll:{
                    btn_0431:true,
                    btn_0432:true,
                    btn_0433:true,
                    btn_0434:true
                },

            }

        },
        created(){
            if(this.getcookie("tenant_id")!="000000"){

                this.updateBtnState("044");
            }

            this.getData();

        },
        methods: {
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            getData(){
                //数据请求
                this.loading = true
                var params = {active:this.activeNum,len:this.pagesize,name:this.topForm.rolename,tenantId:this.getcookie('storeId')};
                //异步请求
                this.$http.post(this.url,params)
                    .then(response => {
                        if (response.status === 200) {
                            this.pagesCount = response.body.total
                            this.tableData = response.body.data
                            this.loading = false;
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            formatter(row, column) {
                var d = new Date(row.time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            handleDelete(row) {
                var params ={params:{"roleId":row.role_id}} ;
                this.$http.get(this.requetHost+"/sys/role/findbyroleId",params)
                    .then(response => {
                    if (response.status === 200)
                {
                    if (response.body.res == "300") {
                        this.$message({showClose: true, message: response.body.msg+'不能被删除', type: 'error'});
                    } else {
                        this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$store.dispatch('delRole', row.role_id).then((data) => {
                            debugger;
                        if (data.res == true) {
                            this.$message({showClose: true, message: '删除成功', type: 'success'});
                            this.getData();
                        } else {
                            this.$message({showClose: true, message: '删除失败，网络异常', type: 'success'});
                        }
                    })
                    })
                    }
                }
            })
            },
            changeCheckRole(){
                this.roleForm.checkLevel='';
            },
            roleEdit(row){
                this.edit = true;
                this.dialogFormVisible=true;
                this.roleForm.role_id=row.role_id;
                this.roleForm.name=row.name;
                this.roleForm.isCheckRole=row.is_check_role;
                this.roleForm.checkLevel=row.check_level;
                this.roleForm.remark=row.remark;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var params={name:this.roleForm.name,isCheckRole:this.roleForm.isCheckRole,checkLevel:this.roleForm.checkLevel,remark:this.roleForm.remark};
                        if(this.roleForm.role_id!=""){
                            params.roleId=this.roleForm.role_id;
                            this.$store.dispatch('editRole',params).then((data)=>{
                                if(data.res==true){
                                    this.$message({showClose: true,message: '保存成功',type: 'success'});

                                    this.getData();
                                }else{
                                    this.$message({showClose: true,message: '参数错误',type: 'error'});
                                }
                                this.dialogFormVisible=false;

                            })
                            resetForm(formName)

                        }else{
                            this.$store.dispatch('saveRole',params).then((data)=>{
                                debugger;
                                if(data.res==true){

                                    this.$message({showClose: true,message: '保存成功',type: 'success'});
                                    this.getData();
                                }else{
                                    this.$message({showClose: true,message: '参数错误',type: 'error'});
                                }
                                this.dialogFormVisible=false;
                            })
                        }

                    }else{
                        console.log('error submit!!');
                        return false;
                    }

                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.getData();
            },
            RolesRes(row){
                //this.$router.push( {name:"configResource",params:{roleId:row.role_id}})
                this.$router.push( {name:"configAuthority",params:{roleId:row.role_id}})

            },
            RoleAuthority(row){

            },
            cleanValue(){
                this.roleForm.role_id="";
                this.roleForm.name="";
                this.roleForm.remark="";
            },
            /**--------------------------------------end--------------------------------------------------------**/
            updateBtnState(pid){
                var _this=this
                this.$store.dispatch("getButton",pid).then((res)=>{
                    var data=res.btnlist;
                    var btnAlllist=new Array("btn_0431","btn_0432","btn_0433","btn_0434");
                    var btnAlllist1=btnAlllist;
                    if(data.length>0) {
                        for (var i = 0; i < data.length; i++) {
                            var btnId="btn_"+data[i].resourceId;
                            for(var j=0;j<btnAlllist.length;j++){
                                if(btnAlllist[j]==btnId){
                                    btnAlllist1.splice(j,1)
                                }
                            } ;
                        }
                        for(var h=0;h<btnAlllist1.length;h++){

                            if(btnAlllist1[h]=="btn_0431"){

                                _this.btnAll.btn_0431=false;
                            }
                            if(btnAlllist1[h]=="btn_0432"){

                                this.btnAll.btn_0432=false;
                            }
                            if(btnAlllist1[h]=="btn_0433"){

                                this.btnAll.btn_0433=false;
                            }
                            if(btnAlllist1[h]=="btn_0434"){

                                this.btnAll.btn_0434=false;
                            }

                        }
                    }

                })
            },
            /**--------------------------------------end--------------------------------------------------------**/

        }

    }

</script>
<style>
    @import "../../../assets/css/button.css";
</style>


// WEBPACK FOOTER //
// RoleManager.vue?d009569a